/**
 * Created by sparakh on 7/22/16.
 *
 */

(function() {
  'use strict';

  EG.Users.Models.Base = Backbone.Model.extend({
    defaults: {
      modelName: 'model',
    },
    initialize: function(attributes, options) {
      this.init(attributes, options);
      this.modelChangeEventCallback();
    },
    init: function() {
      //default implementation of initialization.
    },
    getUserId: function() {
      return this.get('userId') || undefined;
    },
    getModelName: function() {
      return this.get('modelName');
    },
    validation: {},
    setData: function(data) {
      if (data && _.isObject(data)) {
        this.set(data);
      }
    },
    setCustomAttr: function(label, value) {
      var custVal = this[EG.Users.Constants.CUSTOM_ATTR] || {};
      if (_.isObject(custVal)) {
        custVal[label] = value;
        this[EG.Users.Constants.CUSTOM_ATTR] = custVal;
      }
    },
    setValidationRuleConfig: function(ruleConfig) {
      this.validationRuleConfig = ruleConfig;
    },
    toJSON: function(isView) {
      var attrs, customAttributes;

      attrs = _(this.attributes).clone();

      if (_.isObject(this[EG.Users.Constants.CUSTOM_ATTR])) {
        customAttributes = this[EG.Users.Constants.CUSTOM_ATTR];
        if (isView) {
          _.assign(attrs, customAttributes);
        }
      }

      return attrs;
    },

    toJSONRecurse: function(isView) {
      var attrs, customAttributes;

      attrs = _(this.attributes).clone();

      if (_.isObject(this[EG.Users.Constants.CUSTOM_ATTR])) {
        customAttributes = this[EG.Users.Constants.CUSTOM_ATTR];
        if (isView) {
          _.assign(attrs, customAttributes);
        }
      }

      if (this._isSerializing) {
        return this.id || this.cid;
      }

      this._isSerializing = true;

      _.each(attrs, function(value, name) {
        _.isFunction((value || '').toJSON) && (attrs[name] = value.toJSON(isView));
      });

      this._isSerializing = false;

      return attrs;
    },
    deleteCustomAttributes: function() {
      //Delete all custom attributes from model
      if (this[EG.Users.Constants.CUSTOM_ATTR]) {
        delete this[EG.Users.Constants.CUSTOM_ATTR];
      }
    },
    setRetry: function(retry) {
      this.retry = retry;
    },
    hasChanged: function() {
      return Backbone.Model.prototype.hasChanged.call(this);
    },
    publishModelChangeEvent: function(context, options) {
      // publishing an event for analytics.
      var detail = {
        context: context,
        value: this,
        options: options,
      };

      uitk.publish('model.changed.event', detail);
    },
    modelChangeEventCallback: function() {
      var self = this;
      uitk.subscribe('model.changed.event', function(evtName, args) {
        var model = args.value,
          options = args.options;
        // As for every model instance subscriber is registered to handle event,
        // so we need to check for event whether it is for current model or not.
        // Other models will ignore this callback.
        // Currently we are using cid to uniquely recognizing models.
        if (model.cid === self.cid) {
          self.analyse(options);
        }
      });
    },
    analyse: function(options) {
      //default implementation, if nothing is specified in respective models.
    },
    track: function(attributeName, linkId, linkObj) {
      var options;
      if (attributeName in this.changedAttributes()) {
        options = {
          linkId: linkId,
          linkObj: linkObj,
        };
        EG.Users.Profile.userAnalytics.track('a', options);
      }
    },
    /**
     * if type of request is create return back the id to the model
     * if the type is not update, backbone can go on as normal.
     **/
    parse: function(resp, xhr) {
      if (!resp || !resp.type) {
        return resp;
      }

      if (resp.type == 'create') {
        return {
          id: resp.data.id,
        };
      }

      if (resp.type == 'update') {
        return;
      }

      return resp;
    },
    save: function(key, val, options) {
      this.beforeSave(key, val, options);
      return Backbone.Model.prototype.save.call(this, key, val, options);
    },

    beforeSave: function(key, val, options) {},
  });

  EG.Users.Collections.Base = Backbone.Collection.extend({
    isValidCollection: function() {
      var isValid, errors;
      isValid = true;
      errors = this.models.filter(function(model) {
        return model.isValid() === false;
      });
      if (errors.length) {
        isValid = false;
      }
      return isValid;
    },
    isValidationRequired: true,
    hasIndividualModelValidations: false,
    applyValidations: function() {},
    setValidationRuleConfig: function(ruleConfig) {
      this.validationRuleConfig = ruleConfig;
    },
    getUserId: function() {
      return this.userId;
    },
    move: function(model, toIndex) {
      var fromIndex;

      fromIndex = this.indexOf(model);
      if (fromIndex == -1) {
        throw new Error("Can't move a model that's not in the collection");
      }
      if (fromIndex !== toIndex) {
        this.models.splice(toIndex, 0, this.models.splice(fromIndex, 1)[0]);
      }
    },
  });

  _.extend(EG.Users.Models.Base.prototype, Backbone.Validation.mixin);

  /**
   * Store a version of Backbone.sync to call from the
   * modified version we create
   */
  var backboneSync = Backbone.sync;

  /**
   * Adds transactionId request header to all the requests which are initiated via Backbone (fetch, save, etc).
   */
  Backbone.ajax = function() {
      arguments[0].headers = EG.Users.Utils.getHeaders(window.location.href);
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  /**
   * Add transactionId request header to all the requests which are initiated via $.ajax (jquery ajax)
   */
    $.ajaxSettings = $.extend($.ajaxSettings, {
    headers: EG.Users.Utils.getHeaders(window.location.href)
  });
})(EG, document, _);
